import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "onFailure", "overrideConsent", "customFormIdentifier", "customTrackingType", "methods", "onSubmit"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useForm } from 'react-hook-form';
import { v1 as uuidv1 } from 'uuid';
import FormBase from '@segment/matcha/recipes/Form';
import { useTracking } from '@segment/tracking';
import { trackServerError } from '@segment/tracking/scripts';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var TrackableForm = function TrackableForm(_ref) {
  var children = _ref.children,
      onFailure = _ref.onFailure,
      overrideConsent = _ref.overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      _ref$methods = _ref.methods,
      methods = _ref$methods === void 0 ? useForm({
    mode: "all"
  }) : _ref$methods,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTracking = useTracking(),
      identify = _useTracking.identify;

  var submitCallback = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var uniqueId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              uniqueId = uuidv1(); // If there's a custom onSubmit, fire it

              if (!onSubmit) {
                _context.next = 13;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return identify(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), customFormIdentifier && {
                customFormIdentifier: customFormIdentifier
              }), customTrackingType && {
                customTrackingType: customTrackingType
              }), {}, {
                server_message_id: uniqueId // eslint-disable-line camelcase

              }), overrideConsent);

            case 5:
              _context.next = 7;
              return onSubmit(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), customFormIdentifier && {
                customFormIdentifier: customFormIdentifier
              }), customTrackingType && {
                customTrackingType: customTrackingType
              }), {}, {
                server_message_id: uniqueId // eslint-disable-line camelcase

              }));

            case 7:
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              trackServerError(data, customFormIdentifier || "", JSON.stringify(_context.t0));
              methods.setError("root.serverError", {
                type: "400"
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }));

    return function submitCallback(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var errorCallback = function errorCallback(errors) {
    // This can be remove, but is handy for troubleshooting
    console.warn("Form errors!", errors); // If there's a custom onFailure event, fires it.

    if (onFailure) {
      onFailure(errors);
    }
  };

  return _jsx(FormBase, _objectSpread(_objectSpread({
    methods: methods,
    submitCallback: methods.handleSubmit(submitCallback, errorCallback)
  }, rest), {}, {
    children: children
  }));
};

export default TrackableForm;